// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"89eee20d","147":"9c5cbe12","171":"c7a6f6e9","374":"adfefc99","453":"c443520b","507":"71ef4784","801":"885e4030","967":"336c9ea7"}[chunkId] + ".chunk.js";
};